<template>
  <Container type="card-full" drankColor>
    <div class="box">
      <div class="l">
        <!-- <div class="item">
          <span class="filed">项目编号:</span><span class="filed1">{{project.projectcode}}</span>
          <span class="filed">评审方法:</span>
          <span class="filed1">
            {{project.projectdoneflgdesc}}——{{project.projectpricecomputebasisdesc}}<span v-if="project.projectaveragepriceshift">——平均价浮动率:{{project.projectaveragepriceshift}}</span>
          </span>
        </div> -->
        <div style="display: flex; align-items: center">
          <div class="item" style="margin-right: 35px">
            <span class="filed">项目编号:</span>
            <span class="filed1">{{ project.projectcode }}</span>
          </div>
          <div class="item" style="margin-left: 8px">
            <span class="filed">评审方法:</span>
            <span class="filed1">
              {{ project.prsflgdesc }}——{{ project.projectdoneflgdesc
              }}<span v-if="project.prsflg !== '2' && project.prsflg !== '6'">——{{ project.projectpricecomputebasisdesc
              }}</span><span v-if="project.projectaveragepriceshift">——平均价浮动率:{{ project.projectaveragepriceshift
                }}</span>
            </span>
          </div>
         <div style="margin-left: 14px;display:flex">
          <div class="item" style="margin-right: 40px">
            <span class="filed" style="width: 75px;">报名数下限:</span>
            <div class="view-value" v-if="project.prssupplynums > 0">
                {{ project.prssupplynums }}
              </div>
              <div class="view-value" v-else>不限</div>
          </div>
          <div class="item" style="margin-right: 40px">
            <span class="filed" style="width: 75px;">报价数下限:</span>
            <div class="view-value" v-if="project.projectbidderslowerlimit > 0">
                {{ project.projectbidderslowerlimit }}
              </div>
              <div class="view-value" v-else>不限</div>
          </div>
         </div>
        </div>
        <div class="item">
          <span class="filed">项目名称:</span><span class="filed1">{{ project.projectname }}</span>
        </div>
        <div style="display: flex; align-items: center">
          <div class="item" v-if="+project.projectysflg === 1">
            <span class="filed">{{ +this.project.prsflg === 1 ? "项目预算" : "项目底价" }}:</span>
            <span class="filed1">{{ project.projectlimitamt | qfwVal }}</span>
            <span style="font-size: 14px">【</span>
            <amount :money="String(project.projectlimitamt)" style="font-size: 14px" /><span
              style="font-size: 14px">】</span>
          </div>
          <div class="item" style="margin-left: 10px">
            <span class="" style="font-size: 14px; line-height: 30px">报价</span>
            <span class="filed1">{{
            +project.projecthsflg === 1 ? "含税" : "不含税"
            }}</span>
            <span style="padding-left: 20px; font-size: 14px">{{
            projectQuotationmodeflg.one
            }}</span>
          </div>
        </div>
      </div>
      <div class="r">
        <div style="width: 280px">
          <div>
            <span class="filed">开始时间: </span><span class="filed1">{{
            project.prsbjbegtime | newDateTime
            }}</span>
          </div>
          <div>
            <span class="filed time">当前时间: </span><span class="filed1 time">{{ sysDate }}</span>
          </div>
          <div>
            <span class="filed">截止时间: </span><span class="filed1">{{
            project.prsbjendtime | newDateTime
            }}</span>
          </div>
        </div>
        <div class="btn">
          <el-button type="danger" size="medium" @click="quit" icon="el-icon-close">退出大厅</el-button>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="m-r-15">
        <span class="filed">项目员</span>
        <span class="filed1" v-if="project.projecttype === 2">{{ project.hostusercode | keepSecret }}
          <!-- {{ msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
        </span>
        <span class="filed1" v-else>{{ project.hostusercode | keepSecret }}
          <!-- {{ msgList.isOnline >= 0 ? "[在线]" : "[不在线]" }} -->
        </span>
      </div>
      <el-popover placement="top" width="300" v-model="showfy">
        <p>请输入发言内容</p>
        <el-input style="margin: 0 0 20px 0" v-model="moderatorSpeaksMsg" placeholder="请输入内容"></el-input>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="showfy = false">取消</el-button>
          <el-button type="primary" size="mini" @click="moderatorSpeaks">确定</el-button>
        </div>
        <el-button type="primary" slot="reference" size="small" v-if="
          showCGbtn &&
          manipulator
        " @click="showModeratorSpeaks" :disabled="btndisabled.speak">发言</el-button>
      </el-popover>
      <!-- <el-button size="small" class="m-r-15" v-if="showCGbtn" @click="showModeratorSpeaks" :disabled="btndisabled.speak">发言</el-button> -->
      <div class="tip m-r-15">共{{ project.prsbjtimes }}轮</div>
      <el-button type="primary" size="small" :disabled="btndisabled.stjjBoolean" class="m-r-15" v-if="
        showCGbtn &&
        manipulator
      " @click="startJJ" :loading="btnLoading">启动大厅</el-button>
      <el-button type="primary" size="small" :disabled="btndisabled.checkjjBoolean" class="m-r-15" v-if="
        showCGbtn &&
        +project.projectjjfile === 1 &&
        manipulator
      " @click="checkJjPlan">检查{{ fileName }}</el-button>
      <el-button type="primary" size="small" :disabled="btndisabled.uploadBoolean" class="m-r-15"
        v-if="showGYSbtn && +project.projectjjfile === 1 && !myAppendInfo" @click="uploadPlan">上传{{ fileName }}
      </el-button>

      <div class="linkstyle" v-else-if="showGYSbtn && myAppendInfo" @click="downFile(myAppendInfo.appendurl)">
        <a :src="uploadAddr + myAppendInfo.appendurl">{{ fileName }}：{{ myAppendInfo.appendfilename | toolongOmitted
        }}</a>
      </div>
      <template v-if="+project.prsisopen !== 1">
        <el-button type="primary" size="small" :disabled="btndisabled.bjviewBoolean" @click="showbjboxFN">报价一览表
        </el-button>
      </template>
      <el-button type="primary" size="small" :disabled="btndisabled.endjjBoolean" class="m-r-15" v-if="
        showCGbtn &&
        manipulator
      " @click="endJJ" :loading="btnLoading">结束大厅</el-button>
      <div class="time-down" v-if="!timeOut">
        <div class="t">
          <i class="el-icon-time"></i>
          <div>离{{ prsname }}开始还剩</div>
        </div>
        <!-- <div class="back">{{dayNum}}</div>
        <div class="date">天</div> -->
        <div class="back">{{ hourNum }}</div>
        <div class="date">时</div>
        <div class="back">{{ minuteNum }}</div>
        <div class="date">分</div>
        <div class="back">{{ secondNum }}</div>
        <div class="date">秒</div>
      </div>
      <div class="time-down" v-else>
        <div class="dataing">{{ prsname }}进行中</div>
      </div>
    </div>
    <div class="desc-box">
      <div class="bg-white txt">
        <i class="icon el-icon-s-custom"></i>
        <span>在线用户</span>
      </div>
      <div class="content bg-white">
        <div class="tip m-r-15" v-if="this.pbrtime">
          现在进行第{{ pbrtime }}轮
        </div>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.stbjBoolean" v-if="
          showCGbtn &&
          manipulator
        " @click="startBJ" :loading="btnLoading">启动报价</el-button>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.endbjBoolean" v-if="
          showCGbtn &&
          manipulator
        " @click="checkBjInfo">检查报价</el-button>
        <el-button type="primary" size="small" class="m-r-15" @click="showAddRound = true" v-if="(showCGbtn && manipulator) && +pbrtime === +project.prsbjtimes && !btndisabled.endbjBoolean ">增加一轮</el-button>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.endbjBoolean" v-if="
          showCGbtn &&
          manipulator
        " @click="endbj" :loading="endLoading">结束报价</el-button>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.endbjBoolean"
          v-if="showGYSbtn && +project.projectquotationmode === 1" @click="showupload" :loading="btnLoading">本轮报价
        </el-button>
        <el-button type="primary" size="small" class="m-r-15" :disabled="btndisabled.endbjBoolean"
          v-if="showGYSbtn && +project.projectquotationmode !== 1" @click="showOfferfun" :loading="btnLoading">本轮报价
        </el-button>
      </div>
      <div class="bg-white txt">报价屏</div>
    </div>
    <div class="desc-box">
      <div class="message-list bg-white">
        <div class="block">
          <span class="title">
            <i class="icon el-icon-s-custom"></i> <span>代理人</span>
          </span>
          <div v-for="(item, index) in msgList.onLineUser.dlr" :key="index">
            {{ item.usercode }}
          </div>
        </div>
        <div class="block">
          <span class="title">
            <i class="icon el-icon-s-custom"></i> <span>采购人</span>
          </span>
          <div v-for="(item, index) in msgList.onLineUser.cgr" :key="index">
            {{ item.usercode }}
          </div>
        </div>
        <div class="block" v-if="
          +$store.getters.loginUser.comtype === 1 ||
          +$store.getters.loginUser.comtype === 2
        ">
          <span class="title"><i class="icon el-icon-s-custom"></i> <span>供应商</span></span>
          <div v-for="(item, index) in msgList.onLineUser.gys" :key="index">
            {{ item.usercode }}
          </div>
        </div>
      </div>
      <div class="message-content bg-white" ref="msg-content">
        <div v-for="(item, index) in msgList.common" class="item" :key="index">
          {{ item.time }}: {{ item.msg }}
        </div>
      </div>
      <div class="message-list bg-white mss-bjp">
        <div v-if="isBxEd" style="color: #222;font-weight: bold">
            <span v-if="+project.prsbjtimes === 1">请点击【报价一览表】查看报价</span>
            <span v-else="+project.prsbjtimes === 1">请点击【报价一览表】查看报价（多轮次报价的， 最后一轮报价结束后查阅报价一览表）</span>
        </div>
        <div v-else class="item" v-for="(item, index) in msgList.bjview" :key="index">
          <div>第{{ index + 1 }}轮,{{ item.origin.length }}家报价</div>
          <div v-if="
            +project.prsisopen !== 1 &&
            item.origin.length > 0 &&
            +project.projectquotationmode === 1
          ">
            <span>{{ +project.prsflg === 3 ? "最高价" : "最低价" }}</span>{{ item.origin[0].pbramt | qfwVal }}元 (
            <amount :money="String(item.origin[0].pbramt)" v-if="item.origin[0].pbramt" />)
          </div>
          <div v-if="+project.projectquotationmode !== 1 &&  +project.prsisopen !== 1">
            <span>{{ projectQuotationmodeflg.two }}</span>{{ item.origin[0].pbrpricerate }}%
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div>
        <span class="filed">报价必读:</span>
        <div v-html="cosInfo.cosbjreadinfo" v-if="+project.prsflg === 1"></div>
        <div v-html="cosInfo.coszxbjreadinfo" v-if="+project.prsflg === 3"></div>
        <div v-html="cosInfo.coszhbxreadinfo" v-if="+project.prsflg === 6"></div>
      </div>
    </div>
    <!-- 报价弹框 -->
    <div>
      <el-dialog :title="'【' + project.prsflgdesc + '出价】'" :visible.sync="showuploadbox" width="70%">
        <div class="dialog">
          <div class="view-container" style="font-size: 14px; color: #828282">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">项目编号</div>
                  <div class="view-val">{{ project.projectcode }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">采购人</div>
                  <div class="view-val">{{ project.pcomfullname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">项目名称</div>
                  <div class="view-content">{{ project.projectname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field" v-if="+project.projectysflg === 1">
                  <div class="view-label">
                    {{ +this.project.prsflg === 1 ? "项目预算" : "项目底价" }}:
                  </div>
                  <div class="view-val">
                    <span v-if="project.projectlimitamt">
                      ￥{{ project.projectlimitamt | qfwVal }}元 （
                      <amount :money="String(project.projectlimitamt)" />）
                    </span>
                  </div>
                </div>
                <div class="view-field">
                  <span class="view-label">报价{{
                  +project.projecthsflg === 1 ? "含税" : "不含税"
                  }}</span>
                  <span style="
                      padding-left: 20px;
                      font-size: 13px;
                      color: #606266;
                      font-size: 14px;
                    ">{{ projectQuotationmodeflg.one }}</span>
                  <!-- <span class="view-val">{{+project.projecthsflg === 1 ? '含税' : '不含税'}}</span> -->
                </div>
              </div>
              <div class="" v-if="pbrtime > 1">
                <el-divider>【已出价轮次】</el-divider>
                <div class="bjview">
                  <div class="view-row" style="
                      border: 1px solid #828282;
                      padding-bottom: 0;
                      margin: 0 40px;
                    ">
                    <div style="border-right: 1px solid #828282; padding-bottom: 0">
                      <div class="view-field" v-for="i in pbrListASC" :key="i.pbtseq" style="padding: 5px 5px">
                        <div class="view-label">第{{ i.pbtseq }}轮报价</div>
                        <div class="view-val">
                          ￥{{ i.pbramt | qfwVal }}元(
                          <amount :money="String(i.pbramt)" />)
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="view-field" v-for="item in msgList.bjview" :key="item.pbrpbtid">
                        <div class="view-label">
                          本轮{{ +project.prsflg === 3 ? "最高价" : "最低价" }}
                        </div>
                        <div v-if="+project.prsflg === 6">不公开</div>
                        <div class="view-val" v-else>
                          <div v-if="
                            +project.prsisopen !== 1 && item.origin.length > 0
                          ">
                            ￥{{ item.origin[0].pbramt | qfwVal }}元 (
                            <amount :money="String(item.origin[0].pbramt)" v-if="item.origin[0].pbramt" />)
                          </div>
                          <div v-else>不公开</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-divider><span style="color: red">【本轮(第{{ pbrtime }}轮)出价】</span></el-divider>
              <!-- <div class="view-row">
                      <div class="view-field">
                        <div class="view-label">报价共{{project.prsbjtimes}}轮</div>
                        <div class="view-val">已报价{{pbrListASC.length}}轮</div>
                      </div>
                    </div> -->
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label" style="line-height: 38px">
                    本轮报价
                  </div>
                  <div class="view-val">
                    <div style="display: flex;align-items: center;">
                      <div>
                        <el-input v-model="pbrPrice.pbramt" :maxlength="12" @input="veriMoney"
                          @blur="inputMoney($event, 'pbramt')">
                          <template slot="append"><span style="color: red">元(人民币)</span></template>
                        </el-input>
                      </div>
                      <!-- <div style="margin-left:10px;"> -->
                      <el-button type="primary" @click="savePbr" style="margin-left: 10px">提交</el-button>
                      <!-- </div> -->
                      <div style="margin-left: 10px">
                        <el-button type="primary" :disabled="btndisabled.endbjBoolean" v-if="this.pbrtime > 1"
                          @click="previousBj">维持上一次报价</el-button>
                      </div>
                      <upload-btn style="margin-left: 10px" @changed='uploadBmFile' text="上传报价文件" v-if="isShowBmFileBtn"></upload-btn>
                      <a target="_blank" @click="downFile(bmFileAppend.appendurl)" style="margin-left: 10px;cursor: pointer;color: #589ff8" v-if="isShowBmFileBtn">{{ bmFileAppend.appendfilename }}</a>
                    </div>
                    <div style="font-size: 12px; margin-top: 5px" v-if="String(pbrPrice.pbramt)">
                      <amount :money="String(pbrPrice.pbramt)" v-if="pbrPrice.pbramt" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 折扣率/浮动率报价弹框 -->
    <div>
      <el-dialog :title="'【' + project.prsflgdesc + '出价】'" :visible.sync="showOfferbox" width="70%">
        <div class="dialog">
          <div class="view-container" style="font-size: 14px; color: #828282">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">项目编号</div>
                  <div class="view-val">{{ project.projectcode }}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">采购人</div>
                  <div class="view-val">{{ project.pcomfullname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">项目名称</div>
                  <div class="view-content">{{ project.projectname }}</div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field" v-if="+project.projectysflg === 1">
                  <div class="view-label">
                    {{ +this.project.prsflg === 1 ? "项目预算" : "项目底价" }}
                  </div>
                  <div class="view-val">
                    <span v-if="project.projectlimitamt">
                      ￥{{ project.projectlimitamt | qfwVal }}元 （
                      <amount :money="String(project.projectlimitamt)" />）
                    </span>
                  </div>
                </div>
                <div class="view-field">
                  <span class="view-label">报价{{
                  +project.projecthsflg === 1 ? "含税" : "不含税"
                  }}</span>
                  <span style="padding-left: 20px; font-size: 14px; color: #606266">{{ projectQuotationmodeflg.one
                  }}</span>
                  <!-- <span class="view-val">{{+project.projecthsflg === 1 ? '含税' : '不含税'}}</span> -->
                </div>
              </div>
              <div class="" v-if="pbrtime > 1">
                <el-divider>【已出价轮次】</el-divider>
                <div class="bjview">
                  <div class="view-row" style="
                      border: 1px solid #828282;
                      padding-bottom: 0;
                      margin: 0 40px;
                    ">
                    <div style="border-right: 1px solid #828282; padding: 0 20px">
                      <div class="view-field" v-for="i in pbrListASC" :key="i.pbtseq" style="padding: 5px 5px">
                        <div>第{{ i.pbtseq }}轮报价</div>
                        <div class="view-val">
                          {{ projectQuotationmodeflg.one }}{{ i.pbrpricerate }}%
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="view-field" v-for="item in msgList.bjview" :key="item.pbrpbtid"
                        style="padding: 5px 5px">
                        <div>本轮{{ projectQuotationmodeflg.two }}</div>
                        <div class="view-val">
                          <div v-if="
                            +project.prsisopen !== 1 && item.origin.length > 0
                          ">
                            {{ item.origin[0].pbrpricerate }}%
                          </div>
                          <div v-else>不公开</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-divider><span style="color: red">【本轮(第{{ pbrtime }}轮)出价】</span></el-divider>
              <!-- <div class="view-row" style="margin-left:15px;">
                      <div class="view-field">
                        <div class="view-label">报价共{{project.prsbjtimes}}轮</div>
                        <div class="view-val">已报价{{pbrListASC.length}}轮</div>
                      </div>
                    </div> -->

              <div class="view-row">
                <div class="view-field">
                  <div class="view-label" style="line-height: 38px">
                    本轮报价
                  </div>
                  <div class="view-val">
                    <div style="display: flex">
                      <div>
                        <el-input v-model="pbrPrice.pbrpricerate" :maxlength="12" @input="veriMoney">
                          <template slot="append"><span style="color: red">%（{{ projectQuotationmodeflg.three
                          }}）</span></template>
                        </el-input>
                      </div>
                      <!-- @input="veriMoney" @blur="inputMoney($event,'pbramt')" -->
                      <!-- <div style="margin-left:10px;"> -->
                      <el-button type="primary" @click="savePbrpricerate" style="margin-left: 10px">提交</el-button>
                      <!-- </div> -->
                      <div style="margin-left: 10px;display: flex;">
                        <el-button type="primary" :disabled="btndisabled.endbjBoolean" v-if="this.pbrtime > 1"
                          @click="previousBj">维持上一次报价</el-button>
                        <upload-btn style="margin-left: 10px" @changed='uploadBmFile' text="上传报价文件" v-if="isShowBmFileBtn"></upload-btn>
                        <a target="_blank" @click="downFile(bmFileAppend.appendurl)"  style="margin-left: 10px;cursor: pointer;color: #589ff8" v-if="isShowBmFileBtn">{{ bmFileAppend.appendfilename }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 报价一览表 -->
    <div>
      <el-dialog title="报价一览表" :visible.sync="showbjbox" width="70%" height="100%">
        <div id="bjview-box" style="width: 100%">
          <div class="bjview-box" style="margin: 0 auto">
            <div class="bjview-header">
              <div class="bjview-index">序号</div>
              <div class="bjview-name" style="width:400px">竞价单位</div>
              <div class="bjview-list header-jl">
                报价({{ projectQuotationmodeflg.three }})
              </div>
              <div class="bjview-list-r header-jl-r">报价时间</div>
              <div class="bjview-name" style="width:100px;">报价人</div>
            </div>
            <div v-for="(i, index) in dialogList" :key="i.pbrcomid" class="bjview-item">
              <div class="bjview-index">
                <div class="bjview-indexitem">{{ index + 1 }}</div>
              </div>
              <div class="bjview-name" style="width:400px">
                <div class="bjview-comname">{{ i.origin[0].pbrcomname }} </div>
              </div>
              <div class="bjview-list">
                <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                  <div class="item-index" v-if="+project.prsbjtimes > 1">第{{ j.pbtseq }}轮</div>
                  <div class="item-price" v-if="+project.projectquotationmode === 1">
                    ￥{{ j.pbramt | qfwVal }}元(
                    <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
                  </div>
                  <div class="item-price" v-else>{{ j.pbrpricerate }}%</div>
                </div>
              </div>
              <div class="bjview-list-r">
                <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                  <div class="item-index">{{ j.pbrtime | newDate }}</div>
                </div>
              </div>
              <div class="bjview-name" style="width:100px;">
                <!-- <div class="bjview-red" v-if="
                  !btndisabled.confirmQ &&
                  i.origin[0].pbrcomid === $store.getters.loginUser.comid
                ">
                  <el-button type="primary" v-if="pbrList.length === project.prsbjtimes" size="small" class="m-r-15"
                    @click.stop="confirmQuotation">确认报价</el-button>
                </div> -->
                <div class="bjview-red">
                  <!-- <div v-if="
                    +i.origin[0].psuamtcommituserid &&
                    +i.origin[0].psuamtcommituserid !== +i.origin[0].psuuserid
                  ">
                    系统自动确认
                  </div> -->
                  <div>
                    {{ i.origin[0].psuname }}
                    <!-- {{ i.origin[0].psuamtcommittime | newDateTime }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bjview-button" v-if="this.$store.getters.loginUser.comtype === 3">
          <div v-if="pbrList.length != project.prsbjtimes" style="color: red">
            你有未报价轮次，无需确认
          </div>
        </div>
        <div class="bjview-button" v-else>
          <el-button type="primary" class="button-i" @click.stop="lodopPrint">打印</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 方案 -->
    <div>
      <el-dialog :title="`上传${fileName}`" :visible.sync="showuploadfun" width="38%">
        <span style="color: red">只能上传一个文件，如有多个文件，请压缩为一个文件后再上传</span>
        <div class="dialog">
          <!-- 上传竞价附件 -->
          <div class="boxitem">
            <div class="itemname">上传{{ fileName }}</div>
            <div class="itemcon">
              <upload-btn @changed="setfile" text="上传"></upload-btn>
              <div style="color: #2f74ff; cursor: pointer" @click="downFile(append.appendurl)"
                v-if="append.appendfilename">
                <a :src="$store.getters.uploadAddr + append.appendurl">{{
                append.appendfilename
                }}</a>
              </div>
            </div>
          </div>
          <div class="boxitembtn">
            <div class="itembtn">
              <el-button type="primary" @click="uploadfun">提交</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="提醒" :visible.sync="showAddRound" width="70%" height="100%">
      <div>
        <span style="font-size: 14px; font-weight: bold;margin-right: 12px;">增加一轮报价是否需要重新上传报价文件（报价文件按采购文件的要求编制）：</span>
        <el-radio-group v-model="isCospricefile">
          <el-radio :label="0">不需要</el-radio>
          <el-radio :label="1">需要</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button @click="showAddRound = false">取消</el-button>
        <el-button type="primary" @click="insertAddRound">确定</el-button>
      </div>
    </el-dialog>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import config from '../../assets/config'
import uploadBtn from '../common/uploadBtn'
import amount from '../common/amount'
import common from '@/mixin/common'
import io from 'socket.io-client'
import moment from 'moment'
import dayjs from 'dayjs'
import { getLodop } from '@/assets/js/LodopFuncs'
import _ from 'lodash'
// import data from '../component/data'
import { mapGetters } from 'vuex'
let LODOP
// import { isFormData } from 'xe-utils/methods'
// import BetterScroll from 'better-scroll'
/* eslint-disable */
export default {
  name: "pbrCenterForm",
  mixins: [common],
  data() {
    return {
      isCospricefile: 1,
      showAddRound: false,
      showfy: false,
      project: {},
      psuid: this.$route.params.psuid,
      psuInfo: [],
      pbrPrice: {
        pbramt: '',  //报价金额
        pbrpricerate: '',  //报价率
      },
      pbrList: [],
      pbrListASC: [],
      cosInfo: [],
      append: { appendurl: '', appendfilename: '' },
      bmFileAppend: {
        appendid: '',
        bmfilename: ''
      },
      msgList: {
        common: [],
        onLineUser: [],
        bjview: [],     //报价屏
        bjuserList: [],//报价一览表数据
        isOnline: -1 //-1为不在线
      },
      interval: null,
      timeInterval: null,
      days: '0',
      hours: '0',
      minutes: '0',
      seconds: '0',
      date: '',
      psuNum: 0,   //报名人数
      moderatorSpeaksMsg: '',//发言内容
      showCGbtn: false, //采购||代理人按钮显示
      showGYSbtn: false,//供应商按钮显示
      showuploadbox: false,//报价框
      showOfferbox: false,//浮动率=报价框
      pbrtime: 1,//报价次数
      pbtList: [],//轮次信息
      showbjbox: false,//报价一览表显示隐藏
      showuploadfun: false,//上传方案
      showModeratorSpeaksflg: false,
      isEnd: false,
      isStartBj: false,
      btndisabled: {
        speak: false,
        stjjBoolean: true,   //开始竞价
        endjjBoolean: true,  //结束竞价
        checkjjBoolean: true, //检查方案
        stbjBoolean: true,   //开始报价
        endbjBoolean: true,  //结束报价
        weicBoolean: true,   //维持上一次报价
        uploadBoolean: true, //上传方案
        bjviewBoolean: true, //报价一览表
        confirmQ: false,//报价一览表的确认
      },
      UserbjList: [], //供应商的报价列表
      dialogList: [], //弹框数据
      mytitle: '',
      myAppendInfo: {},////自己的方案数据
      btnLoading: false,
      endLoading: false,
      syst: 0
    }
  },
  destroyed() {
    if (this.ispbrCenterClose === 3) {
      // this.$store.commit('close_tab', {routeName: this.$route.name, vm:this, newRouteName:''})
      this._clearData()
    }
    clearInterval(this.timeSetInterval)
    clearInterval(this.systimeInterval)
    clearInterval(this.timeInterval)
  },
  async mounted() {
    // console.log(this.project.prsbjbegtime)
    // setTimeout(() => {
    //   this._initScroll()
    // }, 300)
    this.$nextTick(async () => {
      // this._initScroll()
      // this.bs = new BetterScroll(this.$refs['msg-content'], {
      //   probeType: 3,
      //   y: 400,
      // })
      await this.systime()
      await this.init()
      this.getcositemList()
      await this.getProjectById()
      await this.getPbrList()
      await this.getBjtimes()
      await this.getPbrAllList()
      if (this.showGYSbtn) { //供应商才触发
        this.getAppend()
      }
      // if (moment(new Date()).isBefore(this.project.prsbjendtime)) {
      //   this.time()
      // } else {
      //    this.interval = null
      //    this.sokcet()
      //    this.fromEmit('系统提醒,正式报价开始了', 1)
      // }
      this.sokcet()
      this.timeInterval = setInterval(() => {
        this.date = dayjs().format('YYYY-MM-DD HH:mm:ss')
        // this.date = new Date(this.syst).getTime() + 1000
      }, 1000)
      // this.ispbrCenterClose === 1 && this.$store.commit('SET_ISPBRCENTERCLOSE', 0)
      await this.getBjtimes()         //获取报价次数
      await this.getPsuByprojectId()  //获取应到人数
      this.getbjList()
      // this.getPusInfo() // 获取报名信息
      // if(this.msgList.onLineUser.length === 0){
      //   this.$confirm('网络连接失败,请重新进入大厅', '提示', {
      //     confirmButtonText: '确定',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$store.commit('SET_ISPBRCENTERCLOSE', 3)
      //     this.$store.commit('close_tab', {routeName: this.$route.name, vm:this, newRouteName:''})
      //   }).catch(() => {
      //     this.$store.commit('SET_ISPBRCENTERCLOSE', 3)
      //     this.$store.commit('close_tab', {routeName: this.$route.name, vm:this, newRouteName:''})
      //   })
      // }
      if (moment(new Date()).isBefore(this.project.prsbjbegtime)) {
        this.timeDown()
      }
      if (this.isStartBj && +this.project.prsflg == 6 && +this.project.prsisopen !== 1)  {
          this.isEnd = true
      } else if (this.pbrtime > 1 && !this.isStartBj && +this.project.prsflg == 6 && +this.project.prsisopen !== 1) {
        this.isEnd = true
      }
    })
    window.addEventListener('beforeunload', () => {
      this._clearData()
    })
  },
  watch: {},
  filters: {
    newDateTime(val) {
      return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
    },
    formatComdify(value) {
      return utils.comdify(value)
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    keepSecret(num) {
      var mobile = String(num)
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return mobile.replace(reg, '$1****$2')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4)
        }
        else {
          return val
        }
      }
      return val
    }
  },
  components: { uploadBtn, amount },
  computed: {
    isShowBmFileBtn () {
      return +this.pbrtime > 1
    },
    ...mapGetters(['tabRoutes', 'loginUser', 'ispbrCenterClose']),
    isBxEd () {
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return false
      }
      else {
        if ((this.pbtList && this.pbtList.pbtseq === 1 && this.pbtList.pbtetime) ) {
          return true
        }
        else if (this.isEnd && (this.pbtList && this.pbtList.pbtseq === 1  && this.pbtList.pbtetime)) {
          return true
        } 
        else if (this.isEnd && +this.project.prsflg == 6 && this.pbtList && +this.project.prsisopen !== 1) {
          return true
        } 
        else if (this.isEnd && +this.project.prsflg == 6 && +this.project.prsisopen !== 1) {
          return true
        } 
        else if (this.pbrtime > 1  && +this.project.prsflg == 6 && +this.project.prsisopen !== 1) {
          return true
        }
        // else if (+this.project.prsflg == 6 && this.pbtList && +this.project.prsisopen !== 1) {
        //   return true
        // }

      }
      return false
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
    dayNum() {
      if (this.days < 10) return '0' + this.days
      return this.days
    },
    hourNum() {
      if (this.hours < 10) return '0' + this.hours
      return this.hours
    },
    minuteNum() {
      if (this.minutes < 10) return '0' + this.minutes
      return this.minutes
    },
    secondNum() {
      if (this.seconds < 0) this.seconds = 0
      if (this.seconds < 10) return '0' + this.seconds
      return this.seconds
    },
    timeOut() {
      return this.hourNum === '00' && this.minuteNum === '00' && this.secondNum === '00'
    },
    sysDate() {
      // return utils.formatterDate(new Date(this.date), 'yyyy-MM-dd HH:mm:ss')
      return this.date
    },
    bjviewName() {
      if (this.$store.getters.loginUser.comtype === 3) {
        return '报价结果确认'
      }
      else {
        return '报价一览表'
      }
    },
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '按金额报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '按上浮率报价',
          two: '最高上浮率',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '按下浮率报价',
          two: '最高下浮率',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '按折扣率报价',
          two: '最低折扣率',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额',
        three: '金额'
      }
    },
    Mpbramt() {
      if (+this.project.projectquotationmode === 2) {
        // '最高上浮率报价'
        return this.project.projectlimitamt * (1 + this.pbrPrice.pbrpricerate / 100)
      }
      if (+this.project.projectquotationmode === 3) {
        // '最高下浮率报价'
        return this.project.projectlimitamt * (1 - this.pbrPrice.pbrpricerate / 100)
      }
      if (+this.project.projectquotationmode === 4) {
        // '最低折扣率报价'
        return this.project.projectlimitamt * this.pbrPrice.pbrpricerate / 100
      }
    },
    prsname() {
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return '大厅'
      }
      else {
        return '比选'
      }
    },
    fileName() {
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return '竞价方案'
      }
      else {
        return '评审文件'
      }
    },
    manipulator() {
      return +this.project.projectcuserid === +this.$store.getters.loginUser.userid ||
        (this.$store.getters.loginUser.rolecomtype && this.$store.getters.loginUser.roletype)
    }
  },
  methods: {
    async insertAddRound () {
      await request({
        method: 'post',
        url: 'xmgl/project/insertRound',
        data: {
          projectid:  this.project.projectid,
          isCospricefile: this.isCospricefile
        }
      })
      this.$message.success('增加报价轮次成功')
      this.fromOperate('getProjectById')
      this.fromOperate('getPbrAllList')
      this.socket.emit('fromEmit', {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode,
        msg: {
          projectcode: this.project.projectcode,
          common: {
            msg: '依据本项目采购文件规定，当前项目报价结果触发了新增一轮报价的规定，请报价人提交下一轮报价，如不提交下一轮报价，视同自动放弃继续参与本项目采购的权利。'
          }
        }
      })
      this.showAddRound = false
    },
    uploadBmFile (path, filename) {
      this.bmFileAppend = {
          appendid: 0,
          appendfromid: 0,
          appendfromtype: '16',
          appendtype: '100',
          appendseq: 0,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        }
    },
    changeIsEnd () {
      this.isEnd = false
    },
    async systime() {
      let date = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      let time = +new Date(date)
      this.systimeInterval = setInterval(() => {
        time += 1000
        this.syst = new Date(time)
      }, 1000)
      
    },
    socketContent() {
      this.socketRestInterval = setInterval(() => {
        if (!this.socket) {
          this.sokcet = null
          this.socket = io(config.baseUrl)
        }
        this.socket.on('disconnect', (reason) => {
          this.sokcet = null
          this.socket = io(config.baseUrl)
        })
      }, 1000)
    },
    async timeDown() {
      this.timeSetInterval = setInterval(async () => {
        if (moment(new Date(this.project.prsbjbegtime)).isBefore(moment())) {
          clearInterval(this.timeSetInterval)
        }
        let dur = moment.duration(moment(this.project.prsbjbegtime) - moment(), 'ms')
        this.days = dur.get('days')
        this.hours = dur.get('hours')
        this.minutes = dur.get('minutes')
        this.seconds = dur.get('seconds')
      }, 1000);
    },
    _clearData() {
      this.socket.emit('quit', {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: this.project.projectcode,
        usertype: this.loginUser.comtype,
      })
      this.socket.on('disconnect', function () { })
      clearInterval(this.interval)
      clearInterval(this.timeInterval)
      clearInterval(this.socketRestInterval)
      this.$store.commit('SET_ISPBRCENTERCLOSE', 0)
    },
    fromOperate(m) {
      this.socket.emit('fromOperate', {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode,
        operate: {
          projectcode: this.project.projectcode,
          m: m,
          type: 'method'
        }
      })
    },
    // _initScroll () {
    //   this.bs = new BetterScroll(this.$refs['msg-content'], {
    //     probeType: 3
    //   })
    //   this.bs.on('scroll', (pos) => {
    //     console.log(pos)
    //   })
    // },
    async quit() {
      let msg = '是否退出大厅?'
      if  (+this.$store.getters.loginUser.comtype === 3 && !this.btndisabled.endbjBoolean) {
        let { issuccess = -1 } = await request({
          method: 'get',
          url: '/xmgl/pbr/getPbrByComid',
          params: { pbrprojectid: this.$route.params.projectid, pbrcomid: this.$store.getters.loginUser.comid, pbtseq: this.pbrtime }
        })
        if (issuccess === -1) {
          msg = '您尚未在网上大厅报价（不报价视同自动放弃本项目），是否退出大厅？'
        }
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('SET_ISPBRCENTERCLOSE', 3)
        this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: '' })
      }).catch(() => {
      })
    },
    async getProjectById() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getProjectById',
        params: { projectid: this.$route.params.projectid}
      })
      this.project = res[0]
      this.isCospricefile = this.project.cospricefile === null ? 0 : this.project.cospricefile
    },
    async getAppend() {
      let res = await request({
        method: 'get',
        url: 'ywgl/append/getAppendListByFromId',
        params: { appendfromid: this.$route.params.psuid, appendfromtype: '6' }
      })
      this.myAppendInfo = res[0]
      if (res.length > 0) {
        this.btndisabled.uploadBoolean = true
      }
    },
    time() {
      let that = this
      this.interval = setInterval(() => {
        if (moment(this.project.prsbjendtime).isBefore(moment())) {
          clearInterval(that.interval)
          that.interval = null
          this.sokcet()
          this.fromEmit('系统提醒,正式报价开始了')
        }
        let dur = moment.duration(moment(this.project.prsbjendtime) - moment(), 'ms');
        this.days = dur.get('days')
        this.hours = dur.get('hours')
        this.minutes = dur.get('minutes')
        this.seconds = dur.get('seconds')
      }, 1000)
    },
    sokcet() {
      if (!this.socket) this.socket = io(config.baseUrl)
      let obj = {
        id: this.loginUser.userid,
        usercode: this.loginUser.usercode,
        projectcode: this.project.projectcode,
        usertype: this.loginUser.comtype,
        isCloseStatus: this.ispbrCenterClose
      }
      this.ispbrCenterClose === 2 && (obj.firstTime = moment(new Date()))
      this.socket.emit('onProject', obj)
      this.ispbrCenterClose === 1 && this.socket.emit('getCacheMsg', {
        projectcode: this.project.projectcode,
        id: this.loginUser.userid
      })
      this.socket.on('msg', (data) => {
        if (data.projectcode == this.project.projectcode) {
          if (data.common) {
            !this.msgList['common'] && (this.msgList['common'] = [])
            if (Array.isArray(data.common)) this.msgList['common'] = data.common
            else this.msgList['common'].unshift(data.common)
            // this.bs && this.bs.refresh()
            // this.bs.scrollToElement(this.$refs['test'])
            // this.$refs['msg-content'].scrollTo(0, 300)
          }
          if (data.lineUser) {
            this.msgList['onLineUser'] = data.lineUser
            if (+this.project.projecttype === 2) {
              this.msgList.isOnline = data.lineUser.all.findIndex(item => {
                return item.userid === Number(this.project.projectpuserid)
              })
            }
            else {
              this.msgList.isOnline = data.lineUser.all.findIndex(item => {
                return item.userid === Number(this.project.projectauserid)
              })
            }
          }
          if (data.type === 'method') {
            this[data.m] && this[data.m].bind(this)()
          }
        }
      })
    },
    async init() {
      this.project = {}
      this.pbrPrice.pbramt = ''
      this.pbrPrice.pbrpricerate = ''
      this.pbrList = []
      this.append = { appendurl: '', appendfilename: '' }
      this.date = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      this.date = dayjs(this.date).format('YYYY-MM-DD HH:mm:ss')

      //供应商 显示按钮
      this.showGYSbtn = +this.$store.getters.loginUser.comtype === 3 ? true : false
      //代理||采购 显示按钮
      this.showCGbtn = +this.$store.getters.loginUser.comtype !== 3 ? true : false
    },
    async getPbrList() {//获取自己的所有报价
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getPbrList',
        params: { projectid: this.project.projectid, comid: this.$store.getters.loginUser.comid, orderbyFlg: 'desc' }
      })
      this.pbrList = res
      this.loading = false
    },
    async setfile(path, filename) {
      this.append = {
        appendid: 0,
        appendfromid: this.$route.params.psuid,
        appendfromtype: '6',
        appendtype: '100',
        appendseq: 1,
        appendfilecode: '',
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, '')
      }
    },
    async uploadfun() {
      this.$confirm(`提交后将不能修改`, '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        await request({
          url: 'ywgl/append/addOrEdit',
          method: "post",
          data: this.append
        })
        this.showuploadfun = false
        this.getAppend()
        let usercode = this.telSecret(this.loginUser.usercode)
        this.Speaks(`${usercode}已提交${this.fileName}`)
      })
    },
    telSecret(num) {
      var mobile = String(num)
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return mobile.replace(reg, '$1****$2')
    },
    //SLint: Strings must use singlequote. (quotes
    async savePbrpricerate() {
      const iSprojectdelaypricepermite = this.project.projectdelaypricepermite === 0 ? true: false
      if (!iSprojectdelaypricepermite) {
        let date = await request({
          method: 'get',
          url: 'xtgl/sysdata'
        })
        if (dayjs(date).isAfter(dayjs(this.project.prsbjendtime))) {
          this.$message.warning('当前时间已超过报价截止时间,不允许提交报价')
          return
        }
      }
      if (this.pbrList.length === this.project.prsbjtimes) {
        this.$message.warning('本次报价次数最多为：' + this.project.prsbjtimes + '次')
        return
      }

      if (+this.project.projectquotationmode === 2) {
        // '最高上浮率报价'
        if (+this.pbrPrice.pbrpricerate < 0) {
          this.$message.warning('当前为按上浮率报价，请输入大于或等于0的数字')
          return
        }
      }
      if (+this.project.projectquotationmode === 3) {
        // '最高下浮率报价'
        if (+this.pbrPrice.pbrpricerate >= 100 || +this.pbrPrice.pbrpricerate < 0) {
          this.$message.warning('当前为按下浮率报价，请输入大于或等于0且小于100的数字')
          return
        }
      }
      if (+this.project.projectquotationmode === 4) {
        // '最低折扣率报价'
        if (+this.pbrPrice.pbrpricerate > 100 || +this.pbrPrice.pbrpricerate <= 0) {
          this.$message.warning('当前为按折扣率报价，请输入大于0且小于等于100的数字')
          return

        }
      }


      if (this.pbrList.length) {
        // 递减报价
        if (+this.project.projectquotationmode === 4 && this.pbrList[0].pbrpricerate && Number(this.pbrPrice.pbrpricerate) > Number(this.pbrList[0].pbrpricerate)) {
          this.$message.warning(`该项目规则是${this.projectQuotationmodeflg.one}，报价${this.projectQuotationmodeflg.one}必须小于上一次${this.projectQuotationmodeflg.three}`)
          return
        }
        // 递增报价
        if ((+this.project.projectquotationmode === 2 || +this.project.projectquotationmode === 3) && this.pbrList[0].pbrpricerate && Number(this.pbrPrice.pbrpricerate) < Number(this.pbrList[0].pbrpricerate)) {
          this.$message.warning(`该项目规则是${this.projectQuotationmodeflg.one}，报价${this.projectQuotationmodeflg.three}必须大于上一次${this.projectQuotationmodeflg.three}`)
          return
        }
      }

      let pbtNum = this.pbtList.pbtid
      let model = {
        pbrprojectid: this.project.projectid,
        pbrcomid: this.$store.getters.loginUser.comid,
        pbrpbtid: this.pbtList.pbtid,
        pbramt: this.Mpbramt,
        pbrpricerate: this.pbrPrice.pbrpricerate,
        currentRound: pbtNum,
        prsbjtimes: this.project.prsbjtimes,
        psuid: this.psuid,
        pbruserid: this.$store.getters.loginUser.userid,
        bmFileAppend: this.bmFileAppend
      }
      if (this.isCospricefile === 1 && this.bmFileAppend.bmfilename === '' && +this.pbrtime > 1) {
        this.$message.warning('请上传报价文件')
        return
      }
      // this.submitForm('ruleForm').then(async() => {
      this.$confirm(`您的报价${this.projectQuotationmodeflg.three}为${this.pbrPrice.pbrpricerate}%,是否提交报价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.btnLoading = true
        if (!iSprojectdelaypricepermite) {
          let date = await request({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          if (dayjs(date).isAfter(dayjs(this.project.prsbjendtime))) {
            this.$message.warning('当前时间已超过报价截止时间,不允许提交报价')
            this.btnLoading = false
            return
          }
        }
        let data = await request({
          url: '/xmgl/project/savePbr',
          method: "post",
          data: model
        })

        if (data.issuccess === 2) {
          this.$message.warning('当前轮次已经结束，不能报价')
          this.btnLoading = false
          return
        }

        if (data.issuccess === 3) {
          this.showOfferbox = false
          this.$message.warning('当前轮次已经报价，不能报价')
          this.btnLoading = false
          return
        }

        if (data.issuccess === 1) {
          this.getPbrList()
          this.showOfferbox = false
          this.pbrPrice.pbrpricerate = ''
          this.$message.success('报价成功')
          this.getPbrAllList()
          let usercode = this.telSecret(this.loginUser.usercode)
          this.Speaks(`${usercode},已提交报价`)
          this.bmFileAppend = {
            appendid: '',
            bmfilename: ''
          }

        } else {
          this.btnLoading = false
          this.$message.error('报价失败')
        }
        this.btnLoading = false
      }).catch(() => {
      })

    },
    async savePbr() {
      // let float =  /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
      // if (!float.test(this.pbramt)) {
      //   this.$message.warning('请输入正确的报价金额')
      //   return
      // }
      const iSprojectdelaypricepermite = this.project.projectdelaypricepermite === 0 ? true: false
      if (!iSprojectdelaypricepermite) {
          let date = await request({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          if (dayjs(date).isAfter(dayjs(this.project.prsbjendtime))) {
            this.$message.warning('当前时间已超过报价截止时间,不允许提交报价')
            return
          }
        }
      if (!this.pbrPrice.pbramt) {
        this.$message.warning('请输入正确的报价金额')
        return
      }
      let priceOld = this.pbrPrice.pbramt
      this.pbrPrice.pbramt = utils.delcommafy(this.pbrPrice.pbramt)

      if (this.pbrList.length === this.project.prsbjtimes) {
        this.$message.warning('报价次数最多为：' + this.project.prsbjtimes + '次')
        return
      }
      // if (this.append.appendurl==='' || this.append.appendfilename==='') {
      //   this.$message.warning('必须上传对应的报价文件！')
      //   return
      // }
      if (+this.pbrPrice.pbramt === '' || +this.pbrPrice.pbramt < 0) {
        this.$message.warning('报价金额不能小于0')
        return
      }
      if (this.pbrList.length) {
        // 递减报价
        if ((+this.project.prsflg === 1 || +this.project.prsflg === 6) && this.pbrList[0].pbramt && Number(this.pbrPrice.pbramt) > Number(this.pbrList[0].pbramt)) {
          this.$message.warning(`该项目规则是${this.project.prsflgdesc}，报价金额必须小于或等于上一次报价`)
          return
        }
        // 递增报价
        if (+this.project.prsflg === 3 && this.pbrList[0].pbramt && Number(this.pbrPrice.pbramt) < Number(this.pbrList[0].pbramt)) {
          this.$message.warning(`该项目规则是${this.project.prsflgdesc}，报价金额必须大于或等于上一次报价`)
          return
        }
      }
      // 采购公开预算 供应商报价如果项目是公开报价的，则不能大于项目预算报价+this.project.projectysflg === 1 &&
      if (+this.project.projectysflg === 1 && (+this.project.prsflg === 1 || +this.project.prsflg === 6)) {
        if (Number(this.pbrPrice.pbramt) > Number(this.project.projectlimitamt)) {
          this.$message.warning('报价金额不能大于项目预算' + utils.comdify(this.project.projectlimitamt) + '元')
          return
        }
      }
      if (+this.project.projectysflg === 1 && +this.project.prsflg === 3) {
        if (Number(this.pbrPrice.pbramt) < Number(this.project.projectlimitamt)) {
          this.$message.warning('报价金额不能小于项目底价' + utils.comdify(this.project.projectlimitamt) + '元')
          return
        }
      }

      let pbtNum = this.pbtList.pbtid
      let model = {
        pbrprojectid: this.project.projectid,
        pbrcomid: this.$store.getters.loginUser.comid,
        pbrpbtid: this.pbtList.pbtid,
        pbramt: this.pbrPrice.pbramt,
        currentRound: pbtNum,
        prsbjtimes: this.project.prsbjtimes,
        psuid: this.psuid,
        pbruserid: this.$store.getters.loginUser.userid,
        bmFileAppend: this.bmFileAppend
      }
      if (this.isCospricefile === 1 && this.bmFileAppend.bmfilename === '' && +this.pbrtime > 1) {
        this.$message.warning('请上传报价文件')
        return
      }
      // this.submitForm('ruleForm').then(async() => {
      this.$confirm(`您的报价为${priceOld}元,是否提交报价?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.btnLoading = true
        if (!iSprojectdelaypricepermite) {
          let date = await request({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          if (dayjs(date).isAfter(dayjs(this.project.prsbjendtime))) {
            this.$message.warning('当前时间已超过报价截止时间,不允许提交报价')
            this.btnLoading = false
            return
          }
        }
        let data = await request({
          url: '/xmgl/project/savePbr',
          method: "post",
          data: model
        })

        if (data.issuccess === 2) {
          this.$message.warning('当前轮次已经结束，不能报价')
          this.btnLoading = false
          return
        }

        if (data.issuccess === 3) {
          this.showuploadbox = false
          this.$message.warning('当前轮次已经报价，不能报价')
          this.btnLoading = false
          return
        }

        if (data.issuccess === 1) {
          this.getPbrList()
          this.showuploadbox = false
          this.pbrPrice.pbramt = ''
          this.$message.success('报价成功')
          this.getPbrAllList()
          let usercode = this.telSecret(this.loginUser.usercode)
          this.Speaks(`${usercode},已提交报价`)
          this.bmFileAppend = {
            appendid: '',
            bmfilename: ''
          }

        } else {
          this.$message.error('报价失败')
        }
        this.btnLoading = false
        // }).catch(() => {
        // })
      }).catch(() => {
      })
    },
    // 1 = 系统消息
    fromEmit(msg, type) {
      this.sokcet()
      this.socket.emit('fromEmit', {
        id: this.$store.getters.loginUser.userid,
        msg,
        type,
        projectcode: this.project.projectcode
      })
    },
    // 上传竞价方案
    uploadPlan() {
      this.showuploadfun = true
    },
    async showOfferfun() {
      if (+this.pbrtime > 1) {
        // 上一轮是否有报价
        let model = {}
        model.projectid = this.project.projectid
        model.pbrtime = this.pbrtime - 1
        model.comid = this.$store.getters.loginUser.comid
        let pbdata = await request({
          url: '/xmgl/pbr/previousBj',
          method: "get",
          params: model
        })

        if (+pbdata.issuccess === 0) {
          this.$confirm(`您上一轮报价未参与,视为放弃报价,无需再次报价`, '提示', {
            type: 'warning'
          }).then(async () => {

          }).catch(() => {
          })
        }
        else {
          let res = await request({
            method: 'get',
            url: '/xmgl/project/getPbrList',
            params: { projectid: this.project.projectid, comid: this.$store.getters.loginUser.comid, orderbyFlg: 'asc' }
          })
          this.pbrListASC = res
          this.showOfferbox = true
        }
      }
      else {

        if (!this.myAppendInfo && +this.project.projectjjfile === 1) {
          this.$message.warning(`请先上传${this.fileName}`)
          return
        }
        this.showOfferbox = true
      }

    },
    async showupload() {
      if (+this.pbrtime > 1) {
        // 上一轮是否有报价
        let model = {}
        model.projectid = this.project.projectid
        model.pbrtime = this.pbrtime - 1
        model.comid = this.$store.getters.loginUser.comid
        let pbdata = await request({
          url: '/xmgl/pbr/previousBj',
          method: "get",
          params: model
        })

        if (+pbdata.issuccess === 0) {
          this.$confirm(`您上一轮报价未参与,视为放弃报价,无需再次报价`, '提示', {
            type: 'warning'
          }).then(async () => {

          }).catch(() => {
          })
        }
        else {
          let res = await request({
            method: 'get',
            url: '/xmgl/project/getPbrList',
            params: { projectid: this.project.projectid, comid: this.$store.getters.loginUser.comid, orderbyFlg: 'asc' }
          })
          this.pbrListASC = res
          // for(let i = 0;i < this.msgList.bjview.length;i++){
          //   let bjViewList = this.pbrListASC.filter(v => +v.pbrpbtid === +this.msgList.bjview[i].pbrpbtid)
          //   console.log('bjViewList',bjViewList);

          //   if(bjViewList.length === 0){
          //     bjViewList={
          //       pbramt:'未报价'
          //     }
          //   }
          //   this.msgList.bjview[i].bjViewList = bjViewList
          // }
          this.showuploadbox = true
        }
      }
      else {
        if (!this.myAppendInfo && +this.project.projectjjfile === 1) {
          this.$message.warning(`请先上传${this.fileName}`)
          return
        }
        this.showuploadbox = true
      }
    },
    cacle(val) {//关闭窗口
      this.showbjbox = val
    },
    //上一轮报价
    async previousBj() {
      let model = {}
      model.projectid = this.project.projectid
      model.pbrtime = this.pbrtime - 1
      model.comid = this.$store.getters.loginUser.comid
      let res = await request({
        url: '/xmgl/pbr/previousBj',
        method: "get",
        params: model
      })
      if (res.issuccess === 1) {
        this.pbrPrice.pbramt = res.data.pbramt
        this.pbrPrice.pbrpricerate = res.data.pbrpricerate
        // this.$confirm(`您上一次的报价为${this.pbrPrice.pbramt}元,是否维持该报价`, '提示', {
        //   confirmButtonText: '是',
        //   cancelButtonText: '否',
        //   type: 'warning'
        // }).then(async () => {
        //     this.savePbr()
        // })
      }
      else {
        this.$confirm(`您上一轮报价未参与,本次报价已作废,无需再次报价`, '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async () => {
        })
      }
    },
    // 启动竞价
    async startJJ() {
      await this.getPsuByprojectId()
      const prssupplynums = this.project.prssupplynums || 0
      console.log(prssupplynums, this.psuNum)
      if (prssupplynums !== 0 && this.psuNum < prssupplynums  ) {
        this.socket.emit('fromEmit', {
          id: this.loginUser.userid,
          projectcode: this.project.projectcode,
          msg: {
            projectcode: this.project.projectcode,
            common: {
              msg: '本项目合格报名家数不足采购文件规定的报名下限，本项目采购失败，感谢您的参与，请退出大厅并关注平台公告。'
            }
          }
        })
        return
      }
      this.loading = true
      this.btnLoading = true
      let nowdate = await request({
        method: 'get',
        url: 'xtgl/sysdata'
      })
      if (moment(nowdate).isBefore(this.project.prsbjbegtime)) {
        this.$message.warning(`未到${this.prsname}开始时间`)
        return
      }
      if (moment(nowdate).isAfter(this.project.prsbjendtime)) {
        this.$message.warning(`${this.prsname}已结束`)
        return
      }
      let model = {}
      model.projectid = this.project.projectid
      model.projecthostuserid = this.$store.getters.loginUser.userid
      model.projectjjfile = this.project.projectjjfile
      await request({
        url: '/xmgl/pbr/startJJ',
        method: "post",
        data: model
      })
      let jjtx = ''
      if (this.project.projectjjfile === 1) {
        jjtx = `请供应商提交${this.fileName},并报价。`
      }
      else {
        jjtx = "请供应商做好报价准备"
      }
      // this.Speaks(`本项目有效报名供应商${this.psuNum}人实到${this.msgList.onLineUser.gys.length}人；
      //               采购人${this.msgList.onLineUser.cgr.length}人；
      //               代理机构${this.msgList.onLineUser.dlr.length}人；${jjtx}；
      //               `)
      this.Speaks(`${jjtx}`)
      this.fromOperate('getPbrAllList')
      this.loading = false
      this.btnLoading = false
    },
    // 结束竞价
    async endJJ() {

      this.loading = true
      // let Obj = {}
      // Obj.prsbjtimes = this.project.prsbjtimes
      // Obj.projectid = this.project.projectid

      //查询还有几位供应商未确认报价
      // let num = await request({
      //   url: '/xmgl/pbr/remaining',
      //   method: "get",
      //   params: Obj
      // })

      // if (num) {
      //   this.$confirm(`是否结束竞价`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(async () => {
      //     let from = {}
      //     from.projectid = this.project.projectid
      //     from.prsbjtimes = this.project.prsbjtimes
      //     from.psuamtcommituserid = this.loginUser.userid
      //     let res = await request({
      //       url: '/xmgl/pbr/mandatoryConfirmation',
      //       method: "post",
      //       data: from
      //     })
      //     if (res.issuccess === 1) {
      //       this.$message.success(`${this.prsname}结束`)
      //       this.Speaks(`本项目网上${this.prsname}结束，请退出大厅，等候评审结果发布`)
      //       this.fromOperate('getPbrAllList')
      //     } else {
      //       this.$message.error('失败')
      //     }
      //   }).catch(() => { })
      // }
      // else {
      this.$confirm(`是否结束${this.prsname}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let from = {}
        from.projectid = this.project.projectid
        from.prsbjtimes = this.project.prsbjtimes
        from.psuamtcommituserid = this.loginUser.userid
        let res = await request({
          url: '/xmgl/pbr/mandatoryConfirmation',
          method: "post",
          data: from
        })
        if (res.issuccess === 1) {
          this.$message.success(`${this.prsname}结束`)
          this.Speaks(`本项目网上${this.prsname}结束，请退出大厅，等候评审结果发布`)
          this.fromOperate('getPbrAllList')
        } else {
          this.$message.error('失败')
        }
      }).catch(() => { })
      // }

      this.loading = false

    },
    // 启动报价
    startBJ: _.debounce(async function() {
      // this.getBjtimes()
      // if(this.project.prsbjtimes <= this.pbrtime){
      //     this.$message.warning('超过')
      //     return
      // }
      this.loading = true
      this.btnLoading = true
      let model = {}
      model.phid = 0
      model.pbtprojectid = this.project.projectid
      model.pbtseq = this.pbrtime + 1
      model.phuserid = this.$store.getters.loginUser.userid
      //检查是否提交了文件
      let res = await request({
        url: '/xmgl/pbr/checkJjPlan',
        method: "get",
        params: {
          projectid: this.project.projectid,
          projectbmamt: this.project.projectbmamt,//报名费
          projectbzjamt: this.project.projectbzjamt//保证金
        }
      })
      let newArr = res.filter(e => {
        return e.appendurl === null
      })
      if (newArr.length > 0 && +model.pbtseq === 1 && this.project.projectjjfile === 1) {
        this.$confirm(`还有${newArr.length}位供应商未提交${this.fileName}，是否开始报价`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await request({
            url: '/xmgl/pbr/startbj',
            method: "post",
            data: model
          })
          if (+res.issuccess === -1) {
            this.$$message.warning(res.msg)
          } else {
            this.fromOperate('getBjtimes')
            this.fromOperate('getPbrAllList')
            this.Speaks(`第${this.pbrtime + 1}轮报价开始`)
          }
        }).catch(() => { })
      }
      else {
        this.$confirm(`是否开始第${model.pbtseq}轮报价`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await request({
            url: '/xmgl/pbr/startbj',
            method: "post",
            data: model
          })
          this.fromOperate('getBjtimes')
          this.fromOperate('getPbrAllList')
          this.Speaks(`第${this.pbrtime + 1}轮报价开始`)
        }).catch(() => { })
      }
      this.isStartBj = true
      this.fromOperate('changeIsStartBj')
      this.loading = false
      this.btnLoading = false
    }, 1000, { leading: true }),
    changeIsStartBj () {
      this.isStartBj = true
    },
    // 结束报价
    async endbj(isEndFlg = true) {
      this.loading = true
      this.endLoading = true
      let model = {}
      model.projectid = this.project.projectid
      model.pbtseq = this.pbrtime
      let num = await request({
        url: '/xmgl/pbr/checkbjnum',
        method: "get",
        params: model
      })
      let res = await request({
        url: '/xmgl/pbr/checkBjInfo',
        method: "get",
        params: { projectid: this.project.projectid, pbrtime: this.pbrtime }
      })
      // 报价下限
      const projectbidderslowerlimit = this.project.projectbidderslowerlimit || 0
      // 如果报价下线存在,且报价家数小于报价下限
      if (projectbidderslowerlimit !== 0 && res.length < projectbidderslowerlimit) {
          this.loading = false
          this.endLoading = false
          this.$confirm(`实际报价家数少于报价下限`, '提醒', {
              confirmButtonText: '采购失败',
              cancelButtonText: '等待报价',
              center: true,
              type: 'warning'
            }).then(async () => {
              this.socket.emit('fromEmit', {
                id: this.loginUser.userid,
                projectcode: this.project.projectcode,
                msg: {
                  projectcode: this.project.projectcode,
                  common: {
                    msg: '本项目实际报价家数不足采购文件规定的报价家数下限，本项目采购失败，感谢您的参与，请退出大厅并关注平台公告。'
                  }
                }
              })
            })
      // 如果报价下限存在,报价家数不小于下限,报价家数不等于报名家数
      } else if (projectbidderslowerlimit !== 0 && projectbidderslowerlimit >= res.length && res.length !== this.psuNum  && isEndFlg ) {
          this.loading = false
          this.endLoading = false
        this.$confirm(`尚有供应商未报价`, '提醒', {
              confirmButtonText: '确认结束',
              cancelButtonText: '等待报价',
              center: true,
              type: 'warning'
        }).then(async () => {
              this.endbj(false)
        })
      } else {
        this.isEnd = true
        this.fromOperate('changeIsEnd')
        if (num > 0 && this.pbrtime > 1) {
          this.$confirm(`还有${num}位供应商未报价，是否结束当前报价`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let res = await request({
              url: '/xmgl/pbr/endbj',
              method: "post",
              data: model
            })
            if (res.issuccess === 1) {
              this.isEnd = true
              this.$message.success('报价结束')
              // await this.getBjtimes()
              // await this.getbjList()
              this.fromOperate('getBjtimes')
              this.fromOperate('getbjList')
              this.fromOperate('getPbrAllList')
              let qrbj = ``
              if (+this.pbrtime === +this.project.prsbjtimes) {
                if (+this.project.prsisopen !== 1) {
                  qrbj = `,请点击【报价一览表】查阅报价。`
                  this.fromOperate('showbjboxFN')
                }
              }
              // this.Speaks(`本项目有效报名供应商${this.psuNum}人实到${this.msgList.onLineUser.gys.length}人；
              //          采购人${this.msgList.onLineUser.cgr.length}人；
              //         代理机构${this.msgList.onLineUser.dlr.length}人；${jjtx}；
              //      `)
              this.Speaks(`第${this.pbrtime}轮报价结束，有效报名供应商${this.psuNum}人,已报价${res.length}人${qrbj}`)
              if  (+this.project.prsisopen === 1) {
                this.Speaks(`本项目的报价在成交公告发布后公开，采购失败则不公开报价，请关注平台的采购结果公告。`)
              }
              this.isEnd = true
            } else {
              this.$message.error('失败')
            }
            this.endLoading = false
            this.loading = false
          }).catch(() => {
            this.endLoading = false
            this.loading = false
          })
        } else {
            let res = await request({
              url: '/xmgl/pbr/checkBjInfo',
              method: "get",
              params: { projectid: this.project.projectid, pbrtime: this.pbrtime }
            })

            const count = res

            this.$confirm(`已报价${res.length}人，是否结束当前轮次报价`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              let res = await request({
                url: '/xmgl/pbr/endbj',
                method: "post",
                data: model
              })
              if (res.issuccess === 1) {
                this.$message.success('报价结束')
                // await this.getBjtimes()
                // await this.getbjList()
                this.fromOperate('getBjtimes')
                this.fromOperate('getbjList')
                this.fromOperate('getPbrAllList')
                let qrbj = ``
                if (+this.pbrtime === +this.project.prsbjtimes) {
                  if (+this.project.prsisopen !== 1) {
                     qrbj = `,请点击【报价一览表】查阅报价。`
                  }
                }
               
                this.Speaks(`第${this.pbrtime}轮报价结束，有效报名供应商${this.psuNum}人,已报价${count.length}人${qrbj}`)
                if  (+this.project.prsisopen === 1 && +this.project.prsbjtimes === +this.pbrtime) {
                  this.Speaks(`本项目的报价在成交公告发布后公开，采购失败则不公开报价，请关注平台的采购结果公告。`)
                }
              } else {
                this.$message.error('失败')
              }
              this.endLoading = false
              this.loading = false
            }).catch(() => {
              this.endLoading = false
              this.loading = false
            })
          }
      }
    },
    // 获取当前轮次的报价 pbrcomid pbrpbtid pbrprojectid
    async getUsertimesList() {
      this.loading = true
      let model = {}
      model.pbrprojectid = this.project.projectid
      model.pbrpbtid = this.pbtList.pbtid,
        model.pbrcomid = this.$store.getters.loginUser.usercomid
      model.pbrtime = this.pbrtime
      await request({
        url: '/xmgl/pbr/getUserList',
        method: "get",
        params: model
      })
      // if(res.length > 0){
      //   this.btndisabled.endbjBoolean = true
      // }
      this.loading = false
    },
    //获取当前供应商的所有报价
    async getUserList() {
      this.loading = true
      let model = {}
      model.pbrprojectid = this.project.projectid
      model.pbrpbtid = this.pbtList.pbtid
      model.pbrcomid = this.$store.getters.loginUser.usercomid
      await request({
        url: '/xmgl/pbr/getUserList',
        method: "get",
        params: model
      })
      this.loading = false
    },
    // 获取报价屏数据
    async getbjList() {
      this.loading = true
      let model = {}
      model.pbrprojectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getbjList',
        method: "get",
        params: model
      })

      this.msgList['bjview'] = this.Sortbypbtid(res)
      // for(let i = 0;i < this.pbrtime;i++){
      //   if(!this.msgList.bjview[i] && this.pbrtime > 1){
      //     this.msgList.bjview.push({
      //       pbtid:'',
      //       origin:[]
      //     })
      //   }
      // }
      // console.log('====',this.msgList['bjview']);
      this.loading = false
    },
    // 获取报价一览表数据
    async showbjboxFN() {
      let model = {}
      model.pbrprojectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getbjList',
        method: "get",
        params: model
      })
      if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.pbrcomid === +this.$store.getters.loginUser.comid
        })
      }
      await this.getBjtimes()
      this.dialogList = this.Sortbycomid(res)
      if (this.psuid) {
        await this.getPusInfo()
      }
      if (this.psuInfo.psuamtcommituserid) {
        this.btndisabled.confirmQ = true
      }
      this.showbjbox = true
    },
    Sortbypbtid(beforeData) {
      // 给对象相同数值的合并在一起
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrpbtid) === -1) {
          afterData.push({
            pbrpbtid: beforeData[i].pbrpbtid,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrpbtid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrpbtid == beforeData[i].pbrpbtid) {
              afterData[j].origin.push(beforeData[i]);
              console.log(this.project.prsflg, 'this.project.prsflg')
              if (+this.project.prsflg === 1) {
                afterData[j].origin.sort((a, b) => {
                  return Number(a.pbramt) - Number(b.pbramt)
                })
              }
              if (+this.project.prsflg === 3) {
                afterData[j].origin.sort((a, b) => {
                  return Number(b.pbramt) - Number(a.pbramt)
                })
              }
              break;
            }
          }
        }
      }
      console.log(afterData, 'afterData')
      return afterData
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      return afterData
    },
    // 获取报价第几轮，并且获取报价轮次最后一轮的数据拿id
    async getBjtimes() {
      this.loading = true
      let model = {}
      model.pbtprojectid = this.project.projectid
      let res = await request({
        url: '/xmgl/pbr/getBjtimes',
        method: "get",
        params: model
      })
      this.pbrtime = res.length//第n轮报价
      this.pbtList = res[res.length - 1] //获取最后一轮的数据
      this.loading = false
    },
    //自动发言
    Speaks(msg) {
      this.socket.emit('fromEmit', {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode,
        msg: {
          projectcode: this.project.projectcode,
          common: {
            msg
          }
        }
      })
    },
    inputMoney(el, name) {
      let val = utils.delcommafy(el.target.value)
      var reg = /^[0-9]+.?[0-9]*$/
      if ((reg.test(val))) {
        this.pbrPrice[name] = utils.getInputValue(el)
      }
    },
    veriMoney(e) {
      this.pbrPrice.pbramt = e.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1")
      this.pbrPrice.pbrpricerate = e.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1")
    },
    //获取报名人数
    async getPsuByprojectId() {
      let res = await request({
        url: '/xmgl/pbr/getPsuByprojectId',
        method: "get",
        params: { projectid: this.project.projectid }
      })
      this.psuNum = res.count
    },
    // 检查竞价方案
    async checkJjPlan() {
      this.loading = true
      let res = await request({
        url: '/xmgl/pbr/checkJjPlan',
        method: "get",
        params: {
          projectid: this.project.projectid,
          projectbmamt: this.project.projectbmamt,//报名费
          projectbzjamt: this.project.projectbzjamt//保证金
        }
      })
      let newArr = res.filter(e => {
        return e.appendurl !== null
      })
      // this.Speaks(`实到供应商${this.msgList.onLineUser.gys.length}人，已提交竞价方案${newArr.length}人；`)
      this.Speaks(`已提交${this.fileName}${newArr.length}人`)
      this.loading = false
    },
    //检查报价
    async checkBjInfo() {
      let model = {}
      model.projectid = this.project.projectid
      model.pbtseq = this.pbrtime

      let num = await request({
        url: '/xmgl/pbr/checkbjnum',
        method: "get",
        params: model
      })

      let res = await request({
        url: '/xmgl/pbr/checkBjInfo',
        method: "get",
        params: { projectid: this.project.projectid, pbrtime: this.pbrtime }
      })
      let msg = ''
      if (+num === 0 && this.pbrtime > 1) {
        msg = ''
      } else if (+this.msgList.onLineUser.gys.length === +res.length && +this.pbrtime === 1) {
        msg = ''
      } else {
        msg = '，请尽快提交报价'
      }
      // this.Speaks(`实到供应商${this.msgList.onLineUser.gys.length}人,已报价${res.length}人，${msg}`)
      this.Speaks(`已报价${res.length}人${msg}`)

    },
    //主持人发言
    async showModeratorSpeaks() {
      // this.showModeratorSpeaksflg = true
      this.showfy = true
    },
    moderatorSpeaks() {
      this.socket.emit('fromEmit', {
        id: this.loginUser.userid,
        projectcode: this.project.projectcode,
        msg: {
          projectcode: this.project.projectcode,
          common: {
            msg: this.moderatorSpeaksMsg
          }
        }
      })
      this.moderatorSpeaksMsg = ''
      // this.showModeratorSpeaksflg = false
      this.showfy = false
    },
    async getPbrAllList() {
      this.loading = true
      let model = {
        projectid: this.project.projectid,
        psuid: this.$route.params.psuid,
        comid: this.$store.getters.loginUser.comid
      }
      let res = await request({
        url: '/xmgl/pbr/getPbrAllList',
        method: "get",
        params: model
      })
      let { stjjBoolean,
        endjjBoolean,
        checkjjBoolean,
        stbjBoolean,
        endbjBoolean,
        weicBoolean,
        uploadBoolean,
        bjviewBoolean, speak } = this.btndisabled
      
      //判断显示数据
      if (res.projectlist.projectjkactualbegtime === null) {//竞价没开始
        stjjBoolean = false
        endjjBoolean = true  //结束竞价
        checkjjBoolean = true //检查方案
        stbjBoolean = true   //开始报价
        endbjBoolean = true  //结束报价
        weicBoolean = true   //维持上一次报价
        uploadBoolean = true //上传方案
        bjviewBoolean = true //报价一览表
      }
      else if (res.projectlist.projectjkactualendtime) {//竞价结束后
        speak = true
        stjjBoolean = true   //开始竞价
        endjjBoolean = true  //结束竞价
        checkjjBoolean = true //检查方案
        stbjBoolean = true   //开始报价
        endbjBoolean = true  //结束报价
        weicBoolean = true   //维持上一次报价
        uploadBoolean = true //上传方案
        bjviewBoolean = false //报价一览表
        this.isEnd = true
      }
      else if (res.projectlist.projectjkactualbegtime) {//竞价开始
        stjjBoolean = true
        checkjjBoolean = false //检查方案
        endjjBoolean = true  //结束竞价
        stbjBoolean = false
        if (res.appendlist) {
          if (res.appendlist.length > 0) {
            uploadBoolean = true
          }
          else {
            uploadBoolean = false
          }
        }
        await this.getBjtimes()
        if (res.pbtlist.length > 0) {
          if (+res.pbtlist[res.pbtlist.length - 1].pbtsatus === 0) {//报价开始
            stbjBoolean = true
            endbjBoolean = false
            // console.log('****prsbjtimes***', prsbjtimes)
            if (this.pbrtime > 1) {
              uploadBoolean = true //上传方案
              checkjjBoolean = true //检查方案
            } else {
              uploadBoolean = false //上传方案
              checkjjBoolean = false //检查方案
            }
            if (res.pbrlist.length === this.pbrtime) {
              endbjBoolean = true
            }
          }
          if (+res.pbtlist[res.pbtlist.length - 1].pbtsatus === 1) {//报价结束
            stbjBoolean = false
            endbjBoolean = true
            uploadBoolean = true //上传方案
            checkjjBoolean = true //检查方案
            this.end = true
            if (this.project.prsbjtimes <= this.pbrtime) {
              stbjBoolean = true
              endjjBoolean = false  //结束竞价
              bjviewBoolean = false //报价一览表

            }
            let bjviewBolen = await this.getComfirmPrice()
            if (bjviewBolen) {
              speak = false
              stjjBoolean = true
              endjjBoolean = false  //结束竞价
              checkjjBoolean = true //检查方案
              stbjBoolean = true   //开始报价
              endbjBoolean = true  //结束报价
              weicBoolean = true   //维持上一次报价
              uploadBoolean = true //上传方案
              bjviewBoolean = false //报价一览表
            }
          }
        }
      }
      if (moment(new Date()).isBefore(this.project.prsbjbegtime)) {
        speak = false
        stjjBoolean = false
        endjjBoolean = true  //结束竞价
        checkjjBoolean = true //检查方案
        stbjBoolean = true   //开始报价
        endbjBoolean = true  //结束报价
        weicBoolean = true   //维持上一次报价
        uploadBoolean = true //上传方案
        bjviewBoolean = true //报价一览表
      }
      // if(moment(new Date()).isAfter(this.project.prsbjendtime)){
      //     speak = true
      //     this.btndisabled.stjjBoolean = true
      //     this.btndisabled.endjjBoolean=true  //结束竞价
      //     this.btndisabled.checkjjBoolean = true //检查方案
      //     this.btndisabled.stbjBoolean=true   //开始报价
      //     this.btndisabled.endbjBoolean=true  //结束报价
      //     this.btndisabled.weicBoolean=true   //维持上一次报价
      //     this.btndisabled.uploadBoolean=true //上传方案
      //     this.btndisabled.bjviewBoolean=false //报价一览表
      // }
      this.btndisabled.speak = speak
      this.btndisabled.stjjBoolean = stjjBoolean
      this.btndisabled.endjjBoolean = endjjBoolean  //结束竞价
      this.btndisabled.checkjjBoolean = checkjjBoolean //检查方案
      this.btndisabled.stbjBoolean = stbjBoolean   //开始报价
      this.btndisabled.endbjBoolean = endbjBoolean  //结束报价
      this.btndisabled.weicBoolean = weicBoolean   //维持上一次报价
      this.btndisabled.uploadBoolean = uploadBoolean //上传方案
      this.btndisabled.bjviewBoolean = bjviewBoolean //报价一览表
      this.loading = false
      this.$store.commit('SET_PBRCENTER_INFO', {
        pbtseq: this.pbrtime,
        pbrprojectid: this.project.projectid,
        pbrcomid:this.$store.getters.loginUser.comid,
        endbjBoolean: this.btndisabled.endbjBoolean
      })
    },
    async confirmQuotation() {//
      this.loading = true
      let model = {}
      model.psuid = this.$route.params.psuid
      model.projectid = this.project.projectid
      model.prsbjtimes = this.project.prsbjtimes
      model.psuamt = this.pbrList[0].pbramt
      model.psupricerate = this.pbrList[0].pbrpricerate
      model.pbrtime = this.pbrList[0].pbrtime
      model.psuamtcommituserid = this.$store.getters.loginUser.userid
      let data = await request({
        url: '/xmgl/pbr/confirmQuotation',
        method: "post",
        data: model
      })
      if (data.issuccess === 1) {
        this.$message.success('确认成功')
        this.fromOperate('getPbrAllList')
        this.showbjbox = false
        return
      }
      this.loading = false

    },
    async getPusInfo() {//获取报名信息
      this.loading = true

      let res = await request({
        method: 'get',
        url: '/xmgl/project/getpsubyid',
        params: { psuid: this.$route.params.psuid }
      })

      this.psuInfo = res[0]
      this.loading = false
    },
    async getComfirmPrice() {
      let model = {}
      model.psuprojectid = this.project.projectid
      model.prsbjtimes = this.project.prsbjtimes

      let res = await request({
        method: 'get',
        url: '/xmgl/pbr/getComfirmPrice',
        params: model
      })
      return res
    },
    async getcositemList() {
      this.loading = true

      let res = await request({
        method: 'get',
        url: '/ywgl/cos/getCosbyid',
        params: { cosid: this.$store.getters.loginUser.cosid }
      })

      this.cosInfo = res[0]

      this.loading = false
    },
    async lodopPrint() {  //打印
      let { href } = this.$router.resolve({ name: 'pbrCenterDY', query: { projectid: this.project.projectid } })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.linkstyle {
  color: #2f74ff;
  font-size: 13px;
  margin-right: 20px;
  cursor: pointer;
}

.fliename {
  cursor: pointer;
  color: #2f74ff;
}

.box {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 5px;
  box-sizing: border-box;
  padding: 10px;
  color: #828282;
}

.box .l {
  flex: 1;
}

.box .r {
  width: 380px;
  text-align: right;
  display: flex;
  align-items: center;
}

.box .r .btn {
  flex: 1;
  margin-left: 20px;
}

.box .item {
  display: flex;
  align-items: center;
}

.filed,
.filed1 {
  font-size: 14px;
  line-height: 30px;
}

.filed {
  width: 70px;
}

.filed1 {
  flex: 1;
}

.m-r-15 {
  margin-right: 15px;
}

.tip {
  color: red;
  font-size: 14px;
  font-weight: bold;
  margin-left: 15px;
}

.desc-box {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 5px;
  color: #828282;
}

.desc-box .content {
  width: 60%;
  display: flex;
  align-items: center;
  margin: 0 5px;
  height: 70px;
  box-sizing: border-box;
  padding: 10px;
}

.desc-box .txt {
  height: 70px;
  width: 20%;
  text-align: center;
  line-height: 70px;
}

.message-list {
  width: 20%;
  overflow: auto;
  height: 300px;
  box-sizing: border-box;
  padding: 15px;
}

.message-list .block {
  margin-bottom: 8px;
}

.message-list .title {
  color: #828282;
  font-weight: bold;
}

.message-list .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 4px;
}

.message-content {
  width: 60%;
  overflow: auto;
  height: 300px;
  margin: 0 5px;
  box-sizing: border-box;
  padding: 12px;
}

.message-content .item {
  color: #828282;
  font-size: 14px;
  margin-bottom: 5px;
}

.bg-white {
  background: #fff;
}

ul li {
  font-size: 14px;
  line-height: 32px;
}

.time {
  color: rgb(30, 63, 142);
  font-weight: bold;
}

.boxitem {
  display: flex;
  margin: 10px 10px;
}

.itemname {
  margin-right: 20px;
}

.boxitembtn {
  overflow: hidden;
}

.itembtn {
  float: right;
}

.view-container .view-box {
  margin: 0;
}

.el-divider--horizontal {
  display: block;
  height: 1;
  width: 100%;
  margin: 24px 0;
}

.dialog {
  border: 1px solid #000;
}

.bjview-box {
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.bjview-header {
  display: flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}

.bjview-index {
  text-align: center;
  width: 50px;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-item {
  display: flex;
  line-height: 35px;
}

.bjview-name {
  overflow: hidden;
  width: 210px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-list-r {
  width: 200px;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-name-t {
  overflow: hidden;
  width: 180px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child {
  border-right: none;
}

.header-jl {
  border-bottom: 1px solid #e8eaec;
}

.bjview-list {
  flex: 4;
  -webkit-box-flex: 4;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-list-item {
  display: flex;
  padding-left: 10px;
  border-bottom: 1px solid #e8eaec;
  // height:100%;
}

.bjview-list-item:last-child {

  height: 100%;
}

.item-index {
  // width: 150px;
  flex: 2;
  -webkit-box-flex: 1;
  border-right: 1px solid #e8eaec;
  text-align: center;
}

.item-price {
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}

.bjview-button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-i {
  margin: 30px 0 auto;
  width: 200px;
}

.bjview-red {
  color: red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}

.time-down {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  font-size: 14px;
  margin: 15px 0;
}

.time-down .dataing {
  font-weight: bold;
  color: #e91d1d;
  margin-right: 30px;
}

.time-down .t {
  display: flex;
  align-items: center;
  color: #232323;
  font-weight: bold;
  margin-right: 2px;
}

.time-down .t i {
  font-size: 16px;
}

.time-down .back {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  background-color: #e91d1d;
  text-align: center;
  color: #fff;
  margin: 0 5px;
}

.message-content {
  .item:first-child {
    color: red;
    font-weight: bold;
  }
}

.mss-bjp .item {
  font-weight: bold;
  color: #000 !important;
}
</style>
